var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "494.000000pt",
    height: "20px",
    viewBox: "0 0 494.000000 582.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,582.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2350 5450 c-455 -63 -825 -358 -983 -782 -61 -163 -77 -294 -77 -645 l0 -273 -158 0 c-222 0 -314 -30 -422 -139 -68 -68 -106 -132 -131 -219 -18 -64 -19 -119 -19 -1342 0 -1098 2 -1284 15 -1333 47 -182 180 -315 362 -362 86 -23 3060 -23 3146 0 182 47 315 180 362 362 13 49 15 235 15 1333 0 1223 -1 1278 -19 1342 -48 167 -172 292 -340 342 -40 12 -96 16 -213 16 l-158 0 0 273 c0 351 -16 482 -77 645 -148 396 -482 681 -898 767 -95 20 -313 28 -405 15z m330 -475 c202 -49 375 -176 480 -354 89 -150 113 -288 108 -641 l-3 -225 -755 0 -755 0 -3 225 c-5 353 19 490 109 643 50 86 180 218 263 266 164 97 375 130 556 86z m-27 -2465 c204 -63 343 -255 341 -470 -2 -308 -303 -542 -599 -465 -352 92 -486 508 -254 786 120 144 331 205 512 149z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.6f11b5a48bf2016ca422286cd748310e.svg";
export { ForwardRef as ReactComponent };